<template>
    <CContainer>
        <CRow>
            <CCol sm="12">

                <CTabs variant="pills" @update:activeTab="refreshTab" :active-tab="0">
                    <CTab title="HTML">
                        <div id="htmlCode"></div>
                    </CTab>
                    <CTab title="CSS">
                        <div id="cssCode"></div>
                    </CTab>
                </CTabs>
            </CCol>
        </CRow>

        <CRow alignHorizontal="end">
            <CCol sm="3">
                <CButton :style="{
                    float: 'right',
                }" color="light" @click="eventSave()">
                    Save
                </CButton>
            </CCol>
        </CRow>

    </CContainer>
</template>

<script>
export default {
    name: "ModalCodeEditorEditor",
    data() {
        return {
            modal: null,
            htmlViewer: null,
            cssViewer: null,
            htmlCodeViewer: null,
            cssCodeViewer: null,
        }
    },
    props: {
        editor: {
            required: true
        },
        opts: {
            required: true
        },
        payload: {
            required: true
        }
    },
    methods: {
        eventSave() {
            let html = this.htmlCodeViewer.editor.getValue();
            let css = this.cssCodeViewer.editor.getValue();
            this.editor.DomComponents.getWrapper().set('content', '');
            this.editor.setComponents(html.trim());
            this.editor.setStyle(css);
            this.editor.UndoManager.clear();
            this.editor.Modal.close();
        },
        initHtmlViewer() {
            let html = "";
            if (!this.htmlViewer) {
                let htmlArea = document.createElement('textarea');
                document.querySelector('#htmlCode').appendChild(htmlArea);
                this.htmlCodeViewer.init(htmlArea);
                this.htmlViewer = this.htmlCodeViewer.editor;
                html = this.editor.getHtml();
            } else {
                html = this.htmlCodeViewer.editor.getValue();
            }
            this.htmlCodeViewer.setContent(html);
            this.htmlViewer.refresh();
            this.initCssViewer();
        },
        initCssViewer() {
            let css = "";
            if (!this.cssViewer) {
                let cssArea = document.createElement('textarea');
                document.querySelector('#cssCode').appendChild(cssArea);
                this.cssCodeViewer.init(cssArea);
                this.cssViewer = this.cssCodeViewer.editor;
                css = this.editor.getCss();
            } else {
                css = this.cssCodeViewer.editor.getValue();
            }

            this.cssCodeViewer.setContent(css);
            this.cssViewer.refresh();
        },
        refreshTab(newValue) {
            let html_tap = 0;
            let css_tap = 1;
            switch (newValue) {
                case html_tap:
                    this.initHtmlViewer();
                    break;
                case css_tap:
                    this.initCssViewer();
                    break;
                default:
                    break;
            }
        },
        classesButton() {
            let pfx = this.editor.getConfig().stylePrefix;
            return pfx + 'btn-prim ' + pfx + 'btn-import';
        }
    },
    mounted() {
        this.htmlCodeViewer = this.payload.htmlCodeViewer;
        this.cssCodeViewer = this.payload.cssCodeViewer;
        this.initHtmlViewer();
    }
}
</script>

<style  scoped lang="scss"></style>